import { useQuery } from '@tanstack/react-query';
import productService from 'v2/services/product';

export const useDeliveryIntegrations = () => {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: ['delivery-integrations'],
    queryFn: () => productService.getDeliveryIntegrations()
  });

  return {
    integrations: data,
    isLoading,
    error,
    refetch
  };
};
